import { useStoryInteractor } from '../interactor/useStoryInteractor';
import { StoryView } from '../view/StoryView';

/**
 * Presenter (Controller) for Story Section
 * Connects the Interactor (business logic) with the View (UI)
 */
export const StoryPresenter = () => {
  const { story, onFollowProject } = useStoryInteractor();

  return (
    <StoryView 
      story={story}
      onFollowProject={onFollowProject}
    />
  );
};

export default StoryPresenter;
